import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NetworkHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      const lastPage = sessionStorage.getItem("lastPage");
      if (lastPage && lastPage !== "/offline") {
        sessionStorage.removeItem("lastPage");
        if (location.pathname === "/offline") {
          navigate(lastPage);
        }
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      if (location.pathname !== "/offline") {
        sessionStorage.setItem("lastPage", location.pathname);
        navigate("/offline");
      }
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [navigate, location]);

  return null; // No UI, just handles redirect
};

export default NetworkHandler;
